import Srcset from "@/components/common/Srcset";
import { useRef, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { openMiniCart, addToCart ,openQBMiniCart} from "@/redux/actions/addToCartAction";
import { isMenuVisible, setSearchIcon} from "@/redux/actions/headerAction";
import ReactSidebar from "@/components/common/ReactSidebar";
import Wishlist from "../Wishlist";
import MiniBasket from "@/components/Basket/MiniBasket";
import AccountSideBar from "@/components/Header/Account";
import Bag from "../Bag";
import OlivelaLogo from "@/components/common/OlivelaLogo";
import Search from "../Search";
import MobMenu from "../NavMenu/MobMenu";
import WishlistComp from "@/components/Wishlist";
import styles from "../Header.module.scss";
import mobStyles from "../NavMenu/MobMenu/MobMenu.module.scss";
import Link from "next/link";
import { useRouter } from "next/compat/router";
import { closeReactSidebar, handleOpeningOfAccountSidebar, openAccountSidebar, openAccountSidebarFromPwaHeader, openForgotSidebar, passMsgToAccountSidebar } from "@/redux/actions/loggedInUser";
import { openWishlistSidebar } from "@/redux/actions/wishlistAction";
import { bodyOverflow } from "@/helpers/userHelpers";
import AccountIcon from "@/components/Logos/Account";
import MenuIcon from "@/components/Logos/Menu";
import { getCookie, deleteCookie } from "cookies-next";
import { viewCart } from "@/components/common/Nosto";
import { errorMessages } from "@/utils/constants";
import { setScrollPos } from "@/redux/actions/drawerAction";
// import { navigationTracking } from "@/components/common/Tracking";
import PWAHeader from "../PWAHeader";
import MobileBackNavigation from "../NavMenu/MobMenu/MobileBackNavigation";
import PopUp from "@/components/common/PopUp";
import CharitySelector from "@/components/PWA/WelcomeJourney/CharitySelector";
import { isPWAVisits } from "@/helpers/generalHelper";
import { WelcomeJourneyState, isGuest } from "@/redux/actions/pwaAction";
import { reportError } from "@/helpers/errorHelper";
import RewardsScreen from "@/components/PWA/WelcomeJourney/RewardsScreen";
import WelcomeJourney from "@/components/PWA/WelcomeJourney";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";

export default function MobileMainHeader(props) {
  const dispatch = useDispatch();
  const [disableForgotPass, setDisableForgotPass] = useState(false);
  const [userIcon, setUserIcon] = useState("images/Icons/User.svg");
  const router = useRouter();
  const { selectedIcon, selectIcon } = props;
  // const [editPageState, setEditPageState] = useState(null);
  const [myAccount, setMyAccount] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);
  const basketSidebarOpen = useSelector((state) => state.click.open_mini_cart);
  const navSidebarOpen = useSelector((state) => state.header.isMenuVisible);
  const [mobileStyles, setMobileStyles] = useState({});
  const isMobile = useMediaQuery("(max-width: 767px)");
  const isIpad = useMediaQuery("(max-width: 1200px)");
  
  if (basketSidebarOpen && isMobile) {
    viewCart();
  }
  const engraveSidebarOpen = useSelector((state) => state.click.open_engrave_sidebar);
  const wishlistSidebarOpen = useSelector(
    (state) => state.wishlist.open_wishlist_sidebar
  );
  const accountSidebarOpen = useSelector(
    (state) => state.loginUser.open_account_sidebar
  );

  const isOpeningAccountSidebar = useSelector(
    (state) => state.loginUser.is_opening_account_sidebar
  );
  const closeAccountReactSidebar = useSelector(
    (state) => state.loginUser.close_react_sidebar
  );
  const userLoggedIn = useSelector((state) => state.loginUser.userLoggedIn);
  const quickBuyMinicart= useSelector((state)=> state.click.open_qb_mini_cart)
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  const checkPwaGuest = useSelector((state) => state.pwa.is_guest);
  //  to check user visited PWA for the first
  const [firstVisit, setFirstVisit] = useState(false);
  // check if search icon is already clicked
  const isSearchIcon = useSelector((state) => state.header.setIconSearch);
  const welcomeJourneyStates = useSelector((state) => state.pwa.welcome_journey);
  let showForgotPass = router.asPath.includes("checkoutURL");
  const [showCloseButtonFlag, setshowCloseButtonFlag] = useState(false);

  //to check if search has to be displayed
  useEffect(() => {
    setPageLoaded(true);
    if (window?.history?.state?.url === '/' || router.asPath.startsWith('/?pk_vid') || router.asPath.includes("/account") || router.asPath==="/designer" || router.asPath==="/impact" || router.asPath.includes("/login") || router.asPath.includes("/register")) {
      setShowSearch(true);
    }
    if (isPWA) {
      setMobileStyles({
        sidebar: {
          position: "fixed",
          overflow: "auto",
        },
      });
    } else {
      setMobileStyles({
        root: {
          position: "relative",
          height: 33,
          width: 50,
        },
        sidebar: {
          position: "fixed",
          overflow: "auto",
        },
      });
    }

    //to check if the cross ic0n should be displayed
    if(isPWA && showForgotPass) {
      deleteCookie('hide_signin_cross')
    }


    if(isPWA && getCookie('hide_signin_cross')) {
      setshowCloseButtonFlag(false);
    }
    else if (isPWA && !checkPwaGuest) {
      setshowCloseButtonFlag(true);
    } else if (!isPWA) {
      setshowCloseButtonFlag(true);
    }

  }, []);

  useEffect(() => {
    if (userLoggedIn) {
      setUserIcon("images/Icons/User-Signed-In 2.svg");
    }
  }, [userLoggedIn]);

  const DashboardCloseRef = useRef();
  // ref to calculate the drawer open/close status calculation
  const shouldKeepDrawerOpen = useRef(false)

  //const [navSidebarOpen, setNavSidebarOpen] = useState(false);
  const [mobileAccountBar, setMobileAccountBar] = useState(false);
  const mobileAccountRef = useRef(null);
  let { pages = [] } = router.query;
  // get {drawer_section} value either from [...pages] or directly from the url
  const drawer_section = pages && pages.length ? pages[0] : router.pathname.split("/")[1];
  const drawer_tab = pages && pages.length > 1 ? pages[1] : "";
  const drawer_order_id = pages && pages.length > 2 ? pages[2] : "";

  useEffect(() => {
    if (window.innerWidth <= 768) {
      if ( drawer_section === "account" || drawer_section === "login" || drawer_section === "register" || drawer_section === "activate-account" ) {
        let shouldOpen = true
        if( drawer_tab === "active" ) {
          shouldOpen = false
          let passwordCookie = getCookie(process.env.USER_PASSWORD_COOKIE) || ""
          if( passwordCookie === "" ) {
            shouldOpen = true
          }
        }

        if(router.asPath=="/account/wishlist" && !userLoggedIn){
          shouldOpen=false
        }
    
        if( shouldOpen ) {
          dispatch(closeReactSidebar(true));
          setMobileAccountBar(true);
          dispatch(openAccountSidebar(true));
          handleMobileAccountBar(true);
          // make shouldKeepDrawerOpen false to avoid further calculate drawer open / close status
          shouldKeepDrawerOpen.current = false
          }
           // if drawer state is closed, make shouldKeepDrawerOpen true to further calculate drawer open / close status
        else{
          shouldKeepDrawerOpen.current = true
          }
        }
        // if route is other than account, make shouldKeepDrawerOpen true to further calculate drawer open / close status
      else{
        shouldKeepDrawerOpen.current = true
      }
    }
  }, [router]);
const handleMobileAccountBar = (val) => {

          let refEle;
          if (mobileAccountRef.current) {
            refEle = mobileAccountRef.current.querySelector(".my-account-ref");
          }
          if (val) {
            setMobileAccountBar(val);
            dispatch(closeReactSidebar(true));
            dispatch(openAccountSidebar(val));
            let recursiveCount = 0;
            function waitForEle() {
              /* recursive function. Due to iPhone account drawer issue */
              /* Will run until it found the element for mobile */
              setTimeout(() => {
                refEle = mobileAccountRef.current.querySelector(".my-account-ref");
                if (!refEle) {
                  recursiveCount++;
                  if(recursiveCount < 11) {
                    waitForEle();
                  }
                  else {
                    /* Stop after 10 count */
                    console.error("Mobile account element not found");
                  }
                  
                }
                else {
                  refEle.style.right = "0px";
                }
              }, 100);
            }
            waitForEle();
          } else {
          // refEle.style.right = "-100%";
          setTimeout(() => {

              setMobileAccountBar(val);
              dispatch(closeReactSidebar(false));
              dispatch(openAccountSidebar(val));
              dispatch(openForgotSidebar(val));
              shouldKeepDrawerOpen.current = true
            }, 500);
          }
  };

  useEffect(() => {
    if (welcomeJourneyStates.currentStepNo == 3 && userLoggedIn) {
      dispatch(openAccountSidebar(false))
      handleMobileAccountBar(false);
      dispatch(WelcomeJourneyState({ ...welcomeJourneyStates, addWCOverlay: true, currentStepNo: 4 }));
    }
  },[userLoggedIn])


  useEffect(() => {
    // run this effect only if the shouldKeepDrawerOpen ref is true & user is not logged in to avoid race conditions and condflicts of accountSidebarOpen state
    if (window.innerWidth <= 768 && shouldKeepDrawerOpen.current && !userLoggedIn) {
      if (accountSidebarOpen) {
        // SUP-2841 open the account sidebar only when the sidebar trigger is not done from any other component
        if(!isOpeningAccountSidebar){ 
          handleMobileAccountBar(true);
        }
      }
      else {
        //function to alter drawer signin/register state to false
        handleMobileAccountBar(false);
        //redux function to close mobile navigation drawer with main menu 
        // dispatch(isMenuVisible(false));
        // if the user is on any pages other than accounts, once logged in hide the account side bar
        setMobileAccountBar(false);
        dispatch(closeReactSidebar(false));
        // SUP-2841 make the flag false every time the account sidebar is closed
        dispatch(handleOpeningOfAccountSidebar(false))
      }
    }
  }, [accountSidebarOpen]);

  const handlerBasketSidebar = (e) => {
    //Storing scroll Y position in redux when handler is called
    if(e){
      dispatch(setScrollPos(window.scrollY))
    }
    // sidebar drawer should not open based on the bag icon click for mobile
    dispatch(openMiniCart(false));
    //SUP-2898 : Check global class is added from choose cause partner interaction
    if (document.querySelector("body").classList.contains("cause-sign-in")) {
      //remove global class to retain original drawer state
      setTimeout(() => {
        document.querySelector("body").classList.remove("cause-sign-in");
      }, 500);
    }
  };

  const handleNavSidebar = (e) => {
    //Storing scroll Y position in redux when handler is called
    if(e){ 
      dispatch(setScrollPos(window.scrollY))
    }
    dispatch(isMenuVisible(e));
    // if side bar closes then also set set as false
    if (isPWA) {
      dispatch(setSearchIcon(false))
      props.handleSearchClick()
    }
  };
  
  const handleWishlistSidebar = (e) => {
    //Storing scroll Y position in redux when handler is called
    if(e){
      dispatch(setScrollPos(window.scrollY))
    }
    dispatch(openWishlistSidebar(e));
  };
  useEffect(() => {
    if (typeof document !== "undefined") {
      if (
        basketSidebarOpen ||
        wishlistSidebarOpen ||
        accountSidebarOpen ||
        navSidebarOpen ||
        mobileAccountBar||
        engraveSidebarOpen
      ) {
        bodyOverflow;
      } else {
        bodyOverflow(false);
      }
    }
  }, [
    basketSidebarOpen,
    wishlistSidebarOpen,
    accountSidebarOpen,
    navSidebarOpen,
    mobileAccountBar,
    engraveSidebarOpen
  ]);

  useEffect(() => {
    //SUP-2898 : Handle close transition for account drawer on mobile
    if (mobileAccountBar) {
      if (document.querySelector(".my-account-root").hasChildNodes()) {
        // Added this condition to fix cross button on welcome journey. Cause-sign-in was geting applied everytime the sigin drawer was opened in welcome jounery.
        if(isPWA && welcomeJourneyStates.currentStepNo != 6){
          setTimeout(() => {
            document.querySelector("body").classList.remove("cause-sign-in");
          }, 500);
        }else {
          setTimeout(() => {
            document.querySelector("body").classList.add("cause-sign-in");
          }, 500);
        }
      }
      else {
        setTimeout(() => {
          document.querySelector("body").classList.remove("cause-sign-in");
        },500)
      }
    }
    else {
      setTimeout(() => {
        document.querySelector("body").classList.remove("cause-sign-in");
      },500)
    }
  }, [mobileAccountBar])
  
  const handleAccountBar = (e) => {
    dispatch(openAccountSidebar(e));
    if(e == false) {
      setMyAccount('account');
    } else {
      setMyAccount(false);
    }
    if (document.querySelector("body").classList.contains("cause-sign-in")) {
      setTimeout(() => {
        document.querySelector("body").classList.remove("cause-sign-in");
      }, 500);
    }
  };

  const isSuperbrandHeroPresent = useSelector(
    (state) => state.header.isSuperbrandHeroPresent
  );

  useEffect(()=>{
    if(typeof document !== undefined && isPWA){
      if(document.getElementById("account-drawer-close-button"))
        document.getElementById("account-drawer-close-button").style.top = "64px"
    }
  },[mobileAccountBar])
  
  useEffect(() => { 
    if (welcomeJourneyStates.currentStepNo <= welcomeJourneyStates.totalSteps && !welcomeJourneyStates.isSkipped ) {
      window?.ReactNativeWebView?.postMessage(JSON.stringify({showWcJourney:true}))
    }
    else {
      window?.ReactNativeWebView?.postMessage(JSON.stringify({showWcJourney:false}))
    }
  },[props.showWcJourney, welcomeJourneyStates.currentStepNo <= welcomeJourneyStates.totalSteps && !welcomeJourneyStates.isSkipped]);
  
  return (
    <>
    <section className={`desk_hide ${styles.mob_logo_section}`}>
      <div className="container-fluid">
        <div className="row">
          <div className="grid-md-12 position_relative">
            <MobileBackNavigation/>
            {pageLoaded && <div
              className={`menu_icon ${styles.burger_button}`}
              onClick={() => selectIcon("menu")}
            >
              <ReactSidebar
                mobileStyle={styles.close_button}
                mainContent={
                  !isPWA &&
                   <MenuIcon stroke={isSuperbrandHeroPresent&& !(props.scroll) ?"#ffffff":"#2f2f30"} width="27.75px" height="21px"/>
                }
                sidebarContent={
                  <MobMenu
                    navSidebarOpen={navSidebarOpen}
                    setNavSidebarOpen={handleNavSidebar}
                    setMobileAccountBar={handleMobileAccountBar}
                    topLinks={props.topLinks}
                    isSuperbrandHeroPresent={isSuperbrandHeroPresent}
                    isScroll={props.scroll}
                    handleSearchClick={props.handleSearchClick}
                    selectedIcon={selectedIcon}
                    selectIcon={selectIcon}
                    searchStyle={styles}
                    router={router}
                  />
                }
                handleSidebar={handleNavSidebar}
                sidebarOpen={navSidebarOpen}
                styles={mobileStyles}
                pullRight={false}
              />
              </div>}
              {/* if not pwa then display search icon on every page */}
              {pageLoaded && !isPWA &&  <div
                className={`desktop_header_icon search-icon-mobile mob_search_ele ${styles.search_icon}
                ${styles.icons_wrapper_li} ${
                    selectedIcon == "search"
                      ? `selected ${styles.selected}`
                      : ""
                  }
                `}
                onClick={() => {
                  selectIcon("search");
                  props.handleSearchClick();
                  // if (isPWA) {
                  //   navigationTracking("App: Search");
                  // }
                }}
              >
              <Search isSuperbrandHeroPresent={isSuperbrandHeroPresent && !props.scroll}/>
            </div> }
            {pageLoaded && isPWA && showSearch && <div
              // adding css based sidebar and homepage
              className={`desktop_header_icon search-icon-pwa-mobile mob_search_ele 
                ${isPWA && showSearch ? "pwa-home" : ""}
                ${navSidebarOpen?"":"z-index"}
                ${styles.search_icon}
              `}
              onClick={() => {
                selectIcon("search");
                props.handleSearchClick();
                // is search icon is already clicked then clicking again will set to false.
                !isSearchIcon ? dispatch(setSearchIcon(true)): dispatch(setSearchIcon(false))
              }}
            >
              {/* if PWA then only on home page icon should display */} 
              {isPWA ? showSearch && <Search isSuperbrandHeroPresent={isSuperbrandHeroPresent && !props.scroll} isPWA={isPWA} />: <Search isSuperbrandHeroPresent={isSuperbrandHeroPresent && !props.scroll} isPWA={isPWA} />}
            </div> }
            <div className={`text-center`}>
                <a id="olivela-logo-mob" href="/">
                  {<OlivelaLogo
                    className={`${styles.mob_main_logo}`}
                    superbrandHeroPresent={isSuperbrandHeroPresent && !props.scroll}
                  />}
                </a>
              <span id="mob_icons" className={`${styles.mob_icons_wrapper} ${props.scroll?"z_index":""}`}>
                <ul className={`${styles.icons_wrapper_ul}`}>
                  <li
                    id="search-icon-mobile"
                    className={`desktop_header_icon mob_search_ele ${styles.search_icon} ${
                      styles.ipad_show
                    }
                    ${styles.icons_wrapper_li} ${
                        selectedIcon == "search"
                          ? `selected ${styles.selected}`
                          : ""
                      }
                    `}
                    onClick={() => {
                      selectIcon("search");
                      props.handleSearchClick();
                    }}
                  >
                    <Search isSuperbrandHeroPresent={isSuperbrandHeroPresent && !props.scroll}/>
                  </li>
                  <li
                    className={`desktop_header_icon ${styles.ipad_show} ${styles.icons_wrapper_li} ${
                      styles.user_icon
                    } ${selectedIcon == "user-account" ? "selected" : ""}`}
                    onClick={() => {selectIcon("user-account")}}
                  >
                    <div className="account_slidebar_ipad">
                      <ReactSidebar
                        childSlider={true}
                        parentSlider={navSidebarOpen}
                        mainContent={
                          <div
                            className={`${styles.account_icon} header_account_icon`} onClick={() =>{
                              // dispatch(passMsgToAccountSidebar(""));
                            }}
                          >
                          {userLoggedIn &&  <AccountIcon className="ga_header_account" height="22" width="20" stroke={"#2f2f30"} fill={"#2f2f30"} />}
                          {!userLoggedIn &&  <AccountIcon className="ga_header_account" height="22" width="20" stroke={"#2f2f30"} fill="none" />}
                          </div>
                        }
                        sidebarContent={
                          <AccountSideBar
                            setAccountSidebarOpen={handleAccountBar}
                            accountSidebarOpen={accountSidebarOpen}
                            drawer_section={drawer_section}
                            drawer_tab={drawer_tab}
                            drawer_order_id={drawer_order_id}
                            // editPageState={editPageState}
                            // setEditPageState={setEditPageState}
                            myAccount={myAccount}
                          />
                        }
                        handleSidebar={handleAccountBar}
                        sidebarOpen={accountSidebarOpen && !closeAccountReactSidebar}
                        styles={{
                          root: {
                            position: "relative",
                            height: 40,
                            width: 30,
                          },
                          sidebar: {
                            position: "fixed",
                            overflow: "auto",
                          },
                        }}
                        pullRight={true}
                        sidebarClassName={"mobile-account"}
                      />
                    </div>
                  </li>
                  <li
                    id="fav-icon-mobile"
                    className={`desktop_header_icon ${mobStyles.fav_icon} ${styles.icons_wrapper_li} 
                
                    ${selectedIcon == "wishlist" ? "selected" : ""}`}
                    onClick={() => {
                      selectIcon("wishlist");
                    }}
                  >
                    <ReactSidebar
                      childSlider={true}
                      parentSlider={accountSidebarOpen}
                      mainContent={<Wishlist isSuper={isSuperbrandHeroPresent && !props.scroll} isPWA={isPWA} />}
                      sidebarContent={<WishlistComp />}
                      handleSidebar={handleWishlistSidebar}
                      sidebarOpen={wishlistSidebarOpen}
                      rootClassName={"basket_slidecart"}
                      styles={{
                        root: {
                          position: "relative",
                          height: 30,
                          width: 50,
                        },
                        sidebar: {
                          position: "fixed",
                          overflow: "auto",
                        },
                      }}
                      pullRight={true}
                    />
                  </li>
                  {isIpad && (<li
                    id="basket-icon-mobile"
                    className={`desktop_header_icon position_relative ${styles.icons_wrapper_li} ${mobStyles["bag-icon"]}`}
                    onClick={() => {
                      !quickBuyMinicart ? selectIcon("bag") : selectIcon("search");
                    }}
                  >
                    <ReactSidebar
                      mainContent={<Bag isSuper={isSuperbrandHeroPresent && !props.scroll} isPWA={isPWA} />}
                      sidebarContent={<MiniBasket  isMobile={true}/>}
                      handleSidebar={handlerBasketSidebar}
                      sidebarOpen={basketSidebarOpen}
                      styles={{
                        root: {
                          position: "relative",
                          height: 30,
                          width: 50,
                        },
                        sidebar: {
                          position: "fixed",
                          overflow: "auto",
                        },
                      }}
                      pullRight={true}
                    />
                  </li>)}
                </ul>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="my-account-root" ref={mobileAccountRef}>
        {mobileAccountBar ? (
          <div
            className={`${styles.mobile_account_side_bar} my-account-ref ${isPWA ? "addTopPadding":""} ${welcomeJourneyStates.currentStepNo == 6 ? styles.account_sidebar_transition : ""}`}
            ref={DashboardCloseRef}
          >
              {showCloseButtonFlag && <a id="account-drawer-close-button"
                className={`${styles.close_icon}`}
                onClick={() => {
                  setDisableForgotPass(true)

                  //delete cookie which was added to re open account sidebar for OS-4181
                  if(getCookie('account_reopen')){
                    deleteCookie('account_reopen')
                  }
                  handleMobileAccountBar(false);

                }}
              >
                <Srcset
                  height="18.33"
                  width="18.33"
                  alt="Account"
                  requirePath={true}
                  svgFile={true}
                  src={"images/Icons/Cross/Large.svg"}
                />
              </a>}
            <AccountSideBar
              mobileAccountBar={mobileAccountBar || navSidebarOpen}
              accountSidebarOpen={accountSidebarOpen}
              DashboardCloseRef={DashboardCloseRef}
              drawer_section={drawer_section}
              drawer_tab={drawer_tab}
              drawer_order_id={drawer_order_id}
              handleMobileAccountBar={handleMobileAccountBar}
              disableForgotPass={disableForgotPass}
            />
          </div>
        ) : null}
      </div>
      {isPWA && <PWAHeader handleMobileAccountBar={handleMobileAccountBar}/>}
    </section>
    {isPWA &&<WelcomeJourney showWcJourney={props.showWcJourney} setShowWcJourney={props.setShowWcJourney}/>}
        </>
  );
}
